/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_05_Detail_Beginner_0_HeadingInputs */

const en_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where speed actually comes from`)
};

const es_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De dónde viene realmente la velocidad`)
};

const de_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woher Geschwindigkeit eigentlich kommt`)
};

const zh_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速度真正来自哪里`)
};

const ar_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من أين تأتي السرعة فعلياً`)
};

const fr_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D’où vient réellement la vitesse`)
};

const vi_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tốc độ thực sự đến từ đâu`)
};

const sw_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasi hutoka wapi hasa`)
};

const th_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความเร็วมาจากไหนจริงๆ`)
};

const bs_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otkud zapravo dolazi brzina`)
};

const ja_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピードは本当はどこから生まれるのか`)
};

const ko_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`속도는 실제로 어디서 나올까`)
};

const pt_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De onde vem de verdade a velocidade`)
};

const it_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da dove viene davvero la velocità`)
};

const sv_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Var hastigheten faktiskt kommer ifrån`)
};

const nl_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar snelheid echt vandaan komt`)
};

const da_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvor hastigheden egentlig kommer fra`)
};

const nb_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvor farten egentlig kommer fra`)
};

const fi_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistä vauhti oikeasti tulee`)
};

const pl_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skąd naprawdę bierze się prędkość`)
};

const ru_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откуда на самом деле берётся скорость`)
};

const tr_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hız aslında nereden gelir`)
};

const hi_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रफ़्तार असल में कहाँ से आती है`)
};

const id_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari mana kecepatan sebenarnya berasal`)
};

const ms_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari mana sebenarnya kelajuan datang`)
};

const cs_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkud se rychlost skutečně bere`)
};

const el_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Από πού έρχεται πραγματικά η ταχύτητα`)
};

const he_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מאיפה המהירות באמת מגיעה`)
};

const af_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar spoed eintlik vandaan kom`)
};

const hu_method_content_step_05_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Honnan jön valójában a sebesség`)
};

/**
* | output |
* | --- |
* | "Where speed actually comes from" |
*
* @param {Method_Content_Step_05_Detail_Beginner_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_05_detail_beginner_0_heading = /** @type {((inputs?: Method_Content_Step_05_Detail_Beginner_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_05_Detail_Beginner_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "de") return de_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "th") return th_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "it") return it_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "da") return da_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "id") return id_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "el") return el_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "he") return he_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "af") return af_method_content_step_05_detail_beginner_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_05_detail_beginner_0_heading(inputs)
	return en_method_content_step_05_detail_beginner_0_heading(inputs)
});